<template>
  <!-- A CARDTYPE FOR BRANDS -->
  <nuxt-link
    class="block square relative overflow-hidden my-2 mx-2 bg-black"
    :class="[{ large: large }, { '': !large }]"
    :to="brand.url"
  >
    <!-- LOGO -->

    <div class="absolute h-full w-full flex justify-center items-center">
      <img-svg :src="brand.logo" class="pin m-auto absolute z-30 max-w-half" />
    </div>

    <!-- HOVER EFFECT -->

    <div
      class="color-hover absolute z-20 w-full h-full bg-grey-darker opacity-50 transition"
    />

    <!-- IMAGE -->

    <img
      class="absolute pin special-img-lg z-10 opacity-100 transition"
      :src="brand.image"
      :alt="brand.title"
    />
  </nuxt-link>
</template>

<script>
const req = require.context('~/components/brands/', true, /\.(js|vue)$/i)
const contentComponents = {}
req.keys().forEach((filename) => {
  const name = `${filename.split('.')[1].split('/')[1]}`
  const component = req(filename).default
  contentComponents[name] = component
})

export default {
  components: {
    ...contentComponents,
  },

  props: {
    brand: {
      type: Object,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.square {
  padding-bottom: calc(50% - 1rem);

  width: calc(50% - 1rem);

  svg path {
    fill: white;
  }
}

@screen lg {
  .square {
    padding-bottom: calc(33.33333% - 1rem);

    width: calc(33.33333% - 1rem);
  }
}

.square:hover {
  @apply cursor-pointer;

  .color-hover {
    @apply opacity-0;
  }

  svg path {
    fill: #3c5174;
  }

  img {
    @apply opacity-0;
  }
}

.square.large {
  width: calc(100% - 1rem);
}

@screen lg {
  .square.large {
    width: calc(66.66666% - 1rem);
  }
}

.square:after {
  @apply block m-0;

  content: '';
}
</style>
